export default __webpack_public_path__ + "static/media/23.9be74ce0.jpg";